import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Shield } from 'lucide-react';
import { LogoMarca, NombreMarca } from '../components/Marca';

export default function Login() {
  const { login, marca } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  // Si la sesión se cerró por inactividad (AppContext), se dice por qué — una sola vez.
  const [error, setError] = useState(() => {
    try {
      if (sessionStorage.getItem('cierre_inactividad') !== '1') return '';
      sessionStorage.removeItem('cierre_inactividad');
      return 'Tu sesión se cerró por 30 minutos sin actividad. Vuelve a entrar con tu usuario y contraseña.';
    } catch { return ''; }
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const ok = await login(email, password);
      if (ok) navigate('/');
      else setError('Credenciales incorrectas. Verifica tu correo y contraseña.');
    } catch (err) {
      setError('Error de conexión. Intenta de nuevo.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight:'100vh',
      background:'linear-gradient(135deg, var(--navy) 0%, var(--navy-grad) 50%, var(--steel) 100%)',
      display:'flex', alignItems:'center', justifyContent:'center',
      padding:20, fontFamily:'var(--font)'
    }}>
      <div style={{ position:'fixed', top:'10%', right:'15%', width:300, height:300, borderRadius:'50%', background:'radial-gradient(circle, rgba(var(--sky-rgb),0.08) 0%, transparent 70%)', pointerEvents:'none' }} />
      <div style={{ position:'fixed', bottom:'15%', left:'10%', width:200, height:200, borderRadius:'50%', background:'radial-gradient(circle, rgba(var(--sky-rgb),0.06) 0%, transparent 70%)', pointerEvents:'none' }} />

      <div style={{
        width:'100%', maxWidth:420,
        background:'rgba(var(--steel-rgb),0.4)', border:'1px solid rgba(var(--silver-rgb),0.2)',
        borderRadius:16, padding:40, backdropFilter:'blur(20px)',
        boxShadow:'0 20px 60px rgba(0, 0, 0, 0.4)'
      }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:12, marginBottom:12 }}>
            <LogoMarca size={40} marca={marca} />
            <div style={{ textAlign:'left' }}>
              <NombreMarca marca={marca} fontSize={22} />
              <div style={{ fontSize:11, color:'var(--silver)' }}>Sistema de Gestión</div>
            </div>
          </div>
          <p style={{ fontSize:13, color:'var(--silver)', fontStyle:'italic' }}>{marca?.tagline || 'Gestión integral para corredores de seguros.'}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'var(--silver)', marginBottom:6 }}>Usuario o correo</label>
            {/* Genérico a propósito: el placeholder no debe revelar el formato real de los usuarios ni el dominio */}
            <input type="text" autoCapitalize="none" autoCorrect="off" value={email} onChange={e=>setEmail(e.target.value)} placeholder="usuario  o  usuario@dominio.com" required
              style={{ width:'100%', padding:'12px 16px', background:'rgba(var(--navy-rgb),0.6)', border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:8, fontSize:14, color:'var(--text)', fontFamily:'var(--font)', outline:'none' }}
              onFocus={e=>e.target.style.borderColor='var(--sky)'} onBlur={e=>e.target.style.borderColor='rgba(var(--silver-rgb),0.2)'} />
          </div>

          <div style={{ marginBottom:24 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'var(--silver)', marginBottom:6 }}>Contraseña</label>
            <div style={{ position:'relative' }}>
              <input type={showPass ? 'text' : 'password'} value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required
                style={{ width:'100%', padding:'12px 44px 12px 16px', background:'rgba(var(--navy-rgb),0.6)', border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:8, fontSize:14, color:'var(--text)', fontFamily:'var(--font)', outline:'none' }}
                onFocus={e=>e.target.style.borderColor='var(--sky)'} onBlur={e=>e.target.style.borderColor='rgba(var(--silver-rgb),0.2)'} />
              <button type="button" onClick={()=>setShowPass(!showPass)}
                style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--silver)', display:'flex', alignItems:'center' }}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ background:'rgba(239, 68, 68, 0.1)', border:'1px solid rgba(239, 68, 68, 0.3)', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:13, color:'var(--text-danger)' }}>{error}</div>
          )}

          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:'13px', background: loading ? 'rgba(var(--sky-rgb),0.5)' : 'linear-gradient(135deg, var(--sky), var(--steel))', border:'none', borderRadius:8, cursor: loading ? 'not-allowed' : 'pointer', fontSize:15, fontWeight:700, color:'var(--text)', fontFamily:'var(--font)', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            {loading ? 'Iniciando sesión...' : (<><Shield size={16} /> Iniciar sesión</>)}
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:24, fontSize:12, color:'var(--silver)' }}>{marca?.nombre || 'Corredata'} · Corretaje de Seguros · Panamá</div>
      </div>
    </div>
  );
}
